import { Spinner, Tab, Tabs } from "@blueprintjs/core"
import CustomDialog from "components/Atoms/CustomDialog"
import { useOrderDetailLazyQuery } from "generated/graphql"
import InvoiceSummary from "pages/order/detail/InvoiceSummary"
import OrderInfo from "pages/order/detail/OrderInfo"
import Statuses from "pages/order/detail/Statuses"
import Transanctions from "pages/order/detail/Transanctions"
import React, { useEffect } from "react"
import DownloadOrderInvoice from "./DownloadOrderInvoice"

interface OrderDetailDialogProps {
  /**
   * The order ID to grab details of
   */
  orderId?: string
  isOpen: boolean
  onClose: () => void
}
const OrderDetailDialog = ({
  orderId,
  isOpen,
  onClose,
}: OrderDetailDialogProps) => {
  const [getDetail, { data, loading }] = useOrderDetailLazyQuery()

  useEffect(() => {
    if (orderId && parseInt(orderId)) getDetail({ variables: { id: orderId } })
  }, [orderId, getDetail])

  const orderDetail = data?.orderDetail
  const invoice = data?.orderInvoiceDetail
  const payments = orderDetail?.transactions
  const trackingCode = orderDetail?.trackingCode

  return (
    <CustomDialog
      light
      scrollable={false}
      width="48%"
      isOpen={isOpen}
      onClose={onClose}
      title={`Order - ${trackingCode ?? "NA"}`}
      icon="th-list"
    >
      {loading ? (
        <Spinner />
      ) : (
        <>
          <Tabs>
            <Tab
              title="Details"
              id="info"
              panel={<OrderInfo order={orderDetail} />}
            />
            <Tab
              title="Invoice"
              id="invoice"
              panel={
                <InvoiceSummary
                  invoice={invoice}
                  trackingCode={trackingCode}
                  showDiscount
                />
              }
            />
            <Tab
              title="Payments"
              id="payments"
              panel={
                <Transanctions
                  totalAmount={orderDetail?.totalAmount}
                  totalPaid={orderDetail?.totalPaid}
                  trackingCode={trackingCode}
                  payments={payments}
                />
              }
            />
            <Tabs.Expander />
            <DownloadOrderInvoice
              orderId={orderId}
              billingDocs={orderDetail?.billingDoc}
            />
          </Tabs>
          <Statuses
            deliveryStatus={orderDetail?.deliveryStatus}
            paymentStatus={orderDetail?.paymentStatus}
            orderStatus={orderDetail?.orderStatus}
          />
        </>
      )}
    </CustomDialog>
  )
}

export default OrderDetailDialog
